/*
* CARRITO METHODS
*/

console.log("Carrito script cargado...")

// Form Despacho - Evento Click Select Shipping Method Radio
function setFormDespacho() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
        console.log("button item", buttonDespachoOption)
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked")
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
                buttonDespachoOption.classList.remove('active')
            }
          
            if(document.querySelector("input[name=enova-despacho]:checked")) {
                if( document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda' ) {
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("disabled")
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("active")
                    
                    document.querySelector("#enova-despacho-shipping").classList.remove("active")
                    document.querySelector("#enova-despacho-shipping").classList.add("disabled")


                    /* 
                    * reset deliery
                    */
                    if( document.querySelector("#enova-despacho-delivery-select-fecha") ) {
                        document.querySelector("#enova-despacho-delivery-select-fecha").value = null
                    }

                    if( document.querySelector("input[name=enova-despacho-tipo]:first-child") ) {
                        document.querySelector("input[name=enova-despacho-tipo]:first-child").checked = true
                    }

                    // documento DNI
                    // document.querySelector("input[name=enova-billing-doc]:first-child").checked = true
                    // document.querySelector("input[name=enova-billing-doc]:first-child").click()

                    // if( document.querySelector("#enova-billing-doc-ruc") ) {
                    //     document.querySelector("#enova-billing-doc-ruc").value = ""
                    // }

                    // if ( document.querySelector("#enova-billing-doc-razonsocial") ) {
                    //     document.querySelector("#enova-billing-doc-razonsocial").value = ""
                    // }

                    // Lista stores build
                    //getPickUpShopList(null)

                    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(`
                        <div class="precheckout__disclaimer__bloque">
                            <strong class="precheckout__disclaimer__titulo">Aviso sobre Recojo en Tienda:</strong>
                            <ul class="precheckout__disclaimer__lista">
                                <li>1.- En el siguiente paso, selecciona la opción <strong>"Retiro"</strong></li>
                                <li>2.- Escoge la tienda de tu preferencia y revisa el horario disponible</li>
                                <li>3.- Listo disfruta tu compra</li>
                            </ul>
                        </div>
                    `)
                    

                } else if ( document.querySelector("input[name=enova-despacho]:checked").value === 'delivery' ) {
                    document.querySelector("#enova-despacho-shipping").classList.add("active")
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("active")
    
                    document.querySelector("#enova-despacho-shipping").classList.remove("disabled")
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("disabled")

                    /* 
                    * reset recojo en tienda
                    */
                    if( document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha") ) {
                        document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.remove("active")
                    }

                    if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                        document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null
                    }

                }

                // add class hover active
                document.querySelector("input[name=enova-despacho]:checked").parentElement.classList.add('active')

            }
    
        })
    }
    
}

setFormDespacho()

// Form Despacho - Evento Click Select Billing Doc
function setFormBillingDoc() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
        console.log("button item", buttonDespachoOption)
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked 2")
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
                buttonDespachoOption.classList.remove('active')
            }
          
            if(document.querySelector("input[name=enova-billing-doc]:checked")) {
                if( document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' ) {
                    document.querySelector("#enova-billing-doc").classList.add("active")
                    document.querySelector("#enova-billing-doc").classList.remove("disabled")

                    // validate is "recojo tienda" and "factura"
                    if (
                        document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda'
                    ) {
                        jQuery("#formulario--billing-address_checkbox").prop("checked", false)
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block")
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "none")
                    }
        
                } else if ( document.querySelector("input[name=enova-billing-doc]:checked").value === 'boleta' ) {
                    document.querySelector("#enova-billing-doc").classList.remove("active")
                    document.querySelector("#enova-billing-doc").classList.add("disabled")

                    // reste factura
                    jQuery("#formulario--billing-address_checkbox").prop("checked", true)
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none")
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "block")
                }

                // add class hover active
                document.querySelector("input[name=enova-billing-doc]:checked").parentElement.classList.add('active')

            }
    
        })
    }
    
}

setFormBillingDoc()


// Lista de tienda - evento click
function setStoresEventClick() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
        console.log("button item", buttonDespachoOption)
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked tienda")
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
                buttonDespachoOption.classList.remove('active')
            }
          
            if(document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked")) {
                if(document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha")) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.add("active")
                }

                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null
                }
                
                // add class hover active
                document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked").parentElement.classList.add('active')
            }
    
        })
    }
    
}
setStoresEventClick()

// Calculate shipping methods
function validateDeliveryForm(objectForm) {
    let validated = true
    for(let key in objectForm) {
        console.log("objectForm Value", objectForm[key])

        if(!objectForm || objectForm[key] === '' || objectForm[key] === null) {
            validated = false
        }
    }

    return validated
}



function calculateShippingMethodByUbigeoSelected() {
    if( document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ) {
        document.querySelector("#enova-carrito-block-despacho-shipping__distrito").addEventListener("change", () => {
            
             // Loading block - show
             $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none")
             despachoMethodShippingLoading('loading')

            if(
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito") &&
                (
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "0" &&
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "Seleccione..."
                )
            ) {

                // EVALUAR SI ES UNA COMPRA DE PRODUCTO DIGITAL SOLAMENTE
                getResponseCartItems(true)
                    .then((carritoItemsListE) => {

                        if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                            // es compra digital 
                            // loading false
                            despachoMethodShippingLoading(null)
        
                            // remove shipping active default option
                            jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery").removeClass("active")

                            // Select despacho "servicio"
                            jQuery("#enova-despacho-enova-despacho-servicio-option").attr("checked", true)

                        } else {
                            /*
                            * Request lista de ubigeos
                            */
                            despachoMethodShippingLoading('loading')

                            // REQUEST API SERVICE 
                            let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo") 
                            
                            var carrito_productos = carritoItemsListE.map((el_producto) => {

                                let selectedAttr_peso = el_producto.attributes.find((item_key) => item_key.key === "peso")
                                let selectedAttr_sku = el_producto.attributes.find((item_key) => item_key.key === "sku")

                                return ({
                                    "sku": selectedAttr_sku.value,
                                    "quantity": el_producto.quantity,
                                    "volumen_unit": null,
                                    "weight_unit": selectedAttr_peso.value ? parseFloat(selectedAttr_peso.value) : 0,
                                    "position": null
                                })
                            })
                            

                            // [{"quantity":1,"volumen_unit":null,"weight_unit":null,"position":null}]
                            let productCart = JSON.stringify(carrito_productos)
                            console.log("CARRITO FINAL carrito_productos", productCart)
                            
                            let urlBuilder = `?scope=district-calc-rates&ubigeo=${SelectedDepartamentoUBIGEO}&products=${productCart}`

                            console.log("CARRITO FINAL urlBuilder", urlBuilder)
                            if(SelectedDepartamentoUBIGEO) {
                                fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
                                    method: 'GET',
                                    headers:{
                                        'Content-Type': 'application/json'
                                    }
                                })
                                .then(res => res.json())
                                .then(response => {
                                    console.log('Success:', response)
                                    
                                    // Render Shippinh Methods
                                    SetRenderShippingMethodsListOption(response)
                                    if (getCustomerData("shippingMethodType")) {
                                        let shippingMethodType = getCustomerData("shippingMethodType")
                                        $(`input[name="enova-despacho-tipo"][value="${shippingMethodType}"]`).prop('checked', true).trigger('change');
                                        if (shippingMethodType == "programmed" && shippingMethodType == $('input[name="enova-despacho-tipo"]:checked').val()) {
                                            $(".enova-carrito-block-despacho-shipping__fecha").css("display", "flex")
                                        }
                                    }
                                    

                                    // Loading block - disabled
                                    despachoMethodShippingLoading(null)
                                    
                                })
                                .catch(error => {
                                    console.error('Error:', error)
                                    despachoMethodShippingLoading(null)
                                })

                            } else {
                                alert("Debe seleccionar un Distrito Valido")
                            }
        
                        }

                    })
                    .catch((err) => {
                        console.log("err", err)
                        despachoMethodShippingLoading(null)
                    })
    
            } else {
                // Loading block - disabled
                despachoMethodShippingLoading(null)
            }
        })
    }
}

calculateShippingMethodByUbigeoSelected()


function despachoMethodShippingLoading(status) {
    if (status === 'loading') {
        document.querySelector(".enova-despacho-shipping-loading").classList.add("active")

        // hide shipping methods
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active")
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled")

    } else {
        document.querySelector(".enova-despacho-shipping-loading").classList.remove("active")

        // show shippingm methods
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active")
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled")
    }
}


function calculateShippingMethodToShowOption() {

    for(let methodOption of document.querySelectorAll("input[name=enova-despacho-tipo]")) {
        methodOption.addEventListener("change", (ev) => {
            console.log("label click")
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active")
                $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none")

                if( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-normal") {
                    // none
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "programmed" ) {
                    console.log("label programado")

                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.add("active")
                    $(".enova-carrito-block-despacho-shipping__fecha").css("display", "flex")

                    // jQuery("#enova-despacho-delivery-select-fecha").val()
                    // jQuery("#enova-despacho-delivery-select-horario").val()
                    setLogistictProgrammedDateRules()

                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-express" ) {
                    // none
                } else {
                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active")
                }
            }

        })
    }
}

calculateShippingMethodToShowOption()


function setLogistictProgrammedDateRules() {
    const inputFecha = document.getElementById('enova-despacho-delivery-select-fecha');
    if (!inputFecha) return;

    const hoy = new Date();
    const horaActual = hoy.getHours();
    let horarioCorte = 21; // 9PM
    if ( hoy.toLocaleDateString() == "31/12/2025") {
        horarioCorte = 12
    }
    if ( hoy.toLocaleDateString() == "24/12/2025" ) {
        horarioCorte = 12
    }
    
    const feriados = [
        "30-08-2025", "31-08-2025", "01-11-2025", "02-11-2025", "08-12-2025",
        "09-12-2025", "10-12-2025", "24-12-2025",
        "25-12-2025",
        
        
        "28-12-2025",
        
        
        
        "01-01-2026",
    ];

    function esFeriado(fecha) {
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const anio = fecha.getFullYear();
        const fechaStr = `${dia}-${mes}-${anio}`;
        if (dia === '05' && mes === '08' && anio === '2025') return false;
        return feriados.includes(fechaStr);
    }

    // Limpiar opciones
    inputFecha.innerHTML = '';

    // Obtener ubigeo
    let ubigeo = '150101';
    try {
        const ubigeoElement = $('#enova-carrito-block-despacho-shipping__distrito option:selected');
        if (ubigeoElement.length && ubigeoElement.data('ubigeo')) {
            ubigeo = ubigeoElement.data('ubigeo').toString();
        }
    } catch (e) {}

    let diasHabilesDesdeHoy = 1;

    const fechaInicio = new Date(hoy);
    const diaHoy = hoy.getDay(); // 0 domingo - 6 sábado

    // Ajuste según nueva regla solicitada
    const diasAntesDeCorte = {
        1: 1, // Lunes → +1 → Martes
        2: 1, // Martes → +1 → Miércoles
        3: 1, // Miércoles → +1 → Jueves
        4: 1, // Jueves → +1 → Viernes
        5: 1, // Viernes → +1 → Sábado
        6: 2, // Sábado → +2 → Lunes
        0: 2  // Domingo → +2 → Martes
    };

    const diasDespuesDeCorte = {
        1: 2, // Lunes → +2 → Miércoles
        2: 2, // Martes → +2 → Jueves
        3: 3, // Miércoles → +2 → Viernes
        4: 2, // Jueves → +2 → Sábado
        5: 3, // Viernes → +3 → Lunes
        6: 2, // Sábado → +2 → Lunes
        0: 2  // Domingo → +2 → Martes
    };

    const mapa = horaActual >= horarioCorte ? diasDespuesDeCorte : diasAntesDeCorte;

    fechaInicio.setDate(fechaInicio.getDate() + mapa[diaHoy]);

    // // aplicar leadtime sumando días hábiles reales
    // let avanzados = 0;
    // while (avanzados < diasHabilesDesdeHoy) {
    //     fechaInicio.setDate(fechaInicio.getDate() + 1);
    //     const d = fechaInicio.getDay();
    //     if (d !== 0 && d !== 6 && !esFeriado(fechaInicio)) {
    //         avanzados++;
    //     }
    // }

    // Generar siguientes 7 días válidos
    const diasValidos = [];
    const temp = new Date(fechaInicio);
    const nombres = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    while (diasValidos.length < 7) {
        const d = temp.getDay();
        if (d !== 0 && !esFeriado(temp)) {
            diasValidos.push({
                fecha: formatDateToDDMMYYYY(temp),
                dia: nombres[d]
            });
        }
        temp.setDate(temp.getDate() + 1);
    }

    // Render opciones
    diasValidos.forEach(({ fecha, dia }) => {
        const opt = document.createElement('option');
        opt.value = fecha;
        opt.textContent = `${dia}, ${fecha}`;
        inputFecha.appendChild(opt);
    });

    function formatDateToDDMMYYYY(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${d}-${m}-${y}`;
    }
}

// Llamar a la función después de que el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
    setLogistictProgrammedDateRules();
    setInitCustomerData();
});

// Y también cuando cambie el distrito (si es relevante)
$('#enova-carrito-block-despacho-shipping__distrito').change(function() {
    setLogistictProgrammedDateRules();
});

// [] Formulario to Send Checkout

// crear campos metafields en el pedido V1
// enviar metadatos por API v1

// crear campos metafields en el pedido V2
// enviar metadatos por API v2

function checkoutButtonLoader(status) {
    if(status) {
        jQuery(".loader-button__text_container .loader-button__text").text("Cargando...")
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true")

        jQuery("#enova_cart-data-submit").css("pointer-events", 'none')
        jQuery("#enova_cart-data-submit").css("opacity", '.5')
    } else {
        jQuery(".loader-button__text_container .loader-button__text").text("Ir a Pagar")
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false")

        jQuery("#enova_cart-data-submit").css("pointer-events", 'initial')
        jQuery("#enova_cart-data-submit").css("opacity", '1')
    }
}




function setFakeButtonCart() {
    let templateButtonCart = `
        <div class="enova_terms_conditions_block">
            <label class="enova_terms_conditions_block_terms" for="terms_conditions" style="display: flex;flex-direction: row;align-content: inherit;align-items: baseline;">
                <input type="checkbox" id="terms_conditions"/>
                <p class="enova_terms_text" style="margin-left: 10px;">He leído y acepto los términos y políticas del sitio.</p>
            </label>
        </div>
        <div id="enova_cart-data-submit" is="loader-button" class="cart__checkout-button checkout-button button button--primary button--full">
            <span class="loader-button__text_container">
            <span class="loader-button__text">
                        <span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock   " viewBox="0 0 17 17">
                <path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                <path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                <circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle>
            </svg></span>Ir a pagar</span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
            </span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
        </div>
    `

    if(
        document.querySelector(".cart__recap")
    ) {
        document.querySelector(".cart__recap").innerHTML += templateButtonCart
    } else {
        jQuery(".enova-carrito-block").after(templateButtonCart)
    }


    document.querySelector("#enova_cart-data-submit").addEventListener("click", (ev) => {
        ev.preventDefault()

        if (!jQuery("#terms_conditions").prop("checked")) {
            document.querySelector("#enova-message-carrito").textContent = "Debes aceptar los términos y condiciones"
            document.querySelector("#enova-message-carrito").classList.add("active")
            return false
        }

        document.querySelector("#enova-message-carrito").classList.remove("active")
        document.querySelector("#enova-message-carrito").innerHTML = ""

        console.log("Carrito evento click")

        // document.querySelector("#enova_cart-data-submit")

        // reset obj_params

        function getDocumentValue(typeDocument) {
            let numberDocument = "" 

            if(typeDocument === "factura") {
                numberDocument = document.querySelector("#enova-billing-doc-ruc") ? document.querySelector("#enova-billing-doc-ruc").value : ""
            } else {
                numberDocument = document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
            }

            return numberDocument

        }

        // Carrito notes.attributes
        let type_document = document.querySelector("input[name=enova-billing-doc]:checked") ? document.querySelector("input[name=enova-billing-doc]:checked").value : '';

        function getShippingMatch() {
            //let shippingMethodSelected = document.querySelector("input[name=enova-despacho-tipo]:checked").value
            let addressSelected = document.querySelector("#enova-despacho-direccion").value

            // let formateAddress = document.querySelector("#enova-despacho-direccion") ? `${shippingMethodSelected}: ${addressSelected}` : ""
            let formateAddress = document.querySelector("#enova-despacho-direccion") ? addressSelected : ""
            return formateAddress
        }

        var obj_params = {
            attributes: {
                'pais': 'Peru',
                'Modalidad despacho': document.querySelector("input[name=enova-despacho]:checked") ? document.querySelector("input[name=enova-despacho]:checked").value : "",
                'departamento': document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked").textContent.trim() : "",
                'provincia': document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked").textContent.trim() : "",
                'distrito': document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked").textContent.trim() : "",
                'ubigeo': document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked").dataset.code : "",
                'direccion': getShippingMatch(),
                'referencia': document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
                'comprobante de pago': type_document,
                'email': document.querySelector("#enova-billing-email") ? document.querySelector("#enova-billing-email").value : "", 
                'nombre': document.querySelector("#enova-billing-name") ? document.querySelector("#enova-billing-name").value : "",
                'apellido': document.querySelector("#enova-billing-lastName") ? document.querySelector("#enova-billing-lastName").value : "", 
                'telefono': document.querySelector("#enova-billing-telefono") ? document.querySelector("#enova-billing-telefono").value : "",
                'Documento Identidad': document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
            }
        }

        if(document.querySelector("input[name=enova-despacho-tipo]:checked") && document.querySelector("input[name=enova-despacho-tipo]:checked").value === 'programmed') {
            obj_params['attributes']['fecha de envio'] = document.querySelector("#enova-despacho-delivery-select-fecha").value;
            obj_params['attributes']['horario de recojo'] = document.querySelector("#enova-despacho-delivery-select-horario").value
        }


        if(document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura') {
            obj_params['attributes']['ruc'] = document.querySelector("#enova-billing-doc-ruc").value
            obj_params['attributes']['razon social'] = document.querySelector("#enova-billing-doc-razonsocial").value
        }



        if( document.querySelector("input[name=enova-despacho]:checked") 
        && document.querySelector("input[name=enova-despacho]:checked").value === "delivery" ) {
            obj_params = {
                attributes: {
                    ...obj_params.attributes,
                    'tipo de envio': document.querySelector("input[name=enova-despacho-tipo]:checked") ? document.querySelector("input[name=enova-despacho-tipo]:checked").value : '',
                }
            }
        }
        

        if( document.querySelector("input[name=enova-despacho]:checked") 
        && document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ) {
            obj_params = {
                attributes: {
                    ...obj_params.attributes,
                    'departamento': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.departamento : '',
                    'provincia': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.provincia : '',
                    'distrito': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.distrito : '',
                    'ubigeo': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.ubigeo : '',
                    'direccion': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") && jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? `Recojo Tienda: ${jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-direccion").text()}` : "",
                    'referencia': '-',
                    'tienda recojo': jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-titulo").text() : '',
                    // 'fecha de recojo': document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ? document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value : "",
                    // 'horario de recojo': document.querySelector("#enova-despacho-recojo-tienda-select-hora") ? document.querySelector("#enova-despacho-recojo-tienda-select-hora").value : "",
                }
            }

            if( obj_params && obj_params.attributes && obj_params.attributes['fecha de recojo'] && obj_params.attributes['horario de recojo'] ) {
                obj_params.attributes['referencia'] = `Fecha: ${obj_params.attributes['fecha de recojo']}, Horario: ${obj_params.attributes['horario de recojo']}`
            }
        }



        // validate billing address
        if(
            document.querySelector("input[name=enova-billing-doc]:checked") &&
            document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' &&
            !jQuery("#formulario--billing-address_checkbox").prop("checked") // no hay check, entonces si hay direccion de facturacion diferente
        ) {
            obj_params = {
                attributes: {
                    ...obj_params.attributes,
                    //'facturacion_departamento': document.querySelector("#enova-carrito-block-despacho-billing__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__departamento  option:checked").textContent.trim() : "",
                    //'facturacion_provincia': document.querySelector("#enova-carrito-block-despacho-billing__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__provincia  option:checked").textContent.trim() : "",
                    //'facturacion_distrito': document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked").textContent.trim() : "",
                    //'facturacion_ubigeo': document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked").dataset.code : "",
                    //'facturacion_direccion': document.querySelector("#enova-billing-direccion") ? document.querySelector("#enova-billing-direccion").value : '',
                    //'facturacion_referencia': document.querySelector("#enova-billing-referencia") ? document.querySelector("#enova-billing-referencia").value : ''
                }
            }
        }



        // validate all field not empty
        let formValid = true;
        const skipFieldsPickup = [
            "departamento",
            "provincia",
            "distrito",
            "direccion",
            "referencia",
            "ubigeo",
            "tienda recojo"
        ];

        const isPickup = obj_params.attributes["Modalidad despacho"] === "recojo-tienda";
        for (let cartKey in obj_params.attributes) {
            if (isPickup && skipFieldsPickup.includes(cartKey)) {
                continue;
            }

            if (
                obj_params.attributes[cartKey] === "" ||
                obj_params.attributes[cartKey] === null ||
                obj_params.attributes[cartKey] === undefined
            ) {
                formValid = false;
            }
        }

        const telefonoInput = document.querySelector("#enova-billing-telefono");
        if (telefonoInput && telefonoInput.value.length < 9) {
            formValid = false;
        }

        console.log("DATA", obj_params.attributes)

        /*
        * validate document type
        */
        function validateDocumentTypeForm() {
            var form_type_doc_selected = jQuery("#enova-billing-documento-type").val()
            let input_doc_number = jQuery("#enova-billing-documento-number").val()
            let input_doc_length = jQuery("#enova-billing-documento-number")[0].value.length;
            var form_message_doc_type = ""
            var form_doc_type = true

            if (form_type_doc_selected === "1") {
                // DNI
                if ( 
                    !( input_doc_length === 8  &&  Number(input_doc_number) > 0 )
                ) {
                    // error mesage
                    form_message_doc_type = "El campo Numero DNI debe tener 8 digitos"
                    form_doc_type = false
                    console.log("DNI FAIL")
                }

            } else if (form_type_doc_selected === "2") {
                // CE
                if ( 
                    !( input_doc_length >= 8 && input_doc_length <= 12  &&  /^[a-zA-Z0-9]+$/.test(input_doc_number) )
                ) {
                    // error mesage
                    form_message_doc_type = "El campo Numero Carnet Extranjeria debe tener 8-12 dígitos"
                    form_doc_type = false
                    console.log("CE FAIL")
                }

            } else if (form_type_doc_selected === "3") {
                // RUC
                if ( 
                    !( input_doc_length === 11  &&  Number(input_doc_number) > 0 )
                ) {
                    // error mesage
                    form_message_doc_type = "El campo Numero RUC debe tener 11 dígitos"
                    form_doc_type = false
                    console.log("RUC FAIL")
                }
            }

            // RUC cantidad de dígitos
            // if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
            //     if ( $('#enova-billing-doc-ruc').val().length < 11 ) {
            //         var message_validation = "El campo N de RUC debe tener 11 dígitos"
            //         console.log("RUC FAIL")

            //         document.querySelector("#enova-message-carrito").classList.add("active")
            //         document.querySelector("#enova-billing-doc-ruc").classList.add("input-has-error")
            //         $("#enova-billing-doc-ruc").parent().append(`<p class='text-has-error text-typedoc'>${message_validation}</p>`)
            //         return false
            //     }
            // }


            if (!form_doc_type) {
                // show message error
                // console.log("ERROR TIPO DOCUMENTO", form_message_doc_type)
                document.querySelector("#enova-message-carrito").textContent = form_message_doc_type
                document.querySelector("#enova-message-carrito").classList.add("active")

                // message border 
                document.querySelector("#enova-billing-documento-number").classList.add("input-has-error")

                // validation text
                if ( $(".text-has-error.text-typedoc").length == 0 ) {
                    $("#enova-billing-documento-number").parent().append(`<p class='text-has-error text-typedoc'>${form_message_doc_type}</p>`)
                } else {
                    $("p.text-has-error.text-typedoc").text(form_message_doc_type)
                }
              
            } else {
                // console.log("BIEN TIPO DOCUMENTO")
                document.querySelector("#enova-message-carrito").textContent = ""
                document.querySelector("#enova-message-carrito").classList.remove("active")

                document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error")
                $("p.text-has-error.text-typedoc").remove()

            }

            return form_doc_type
        }

        var isTypeDocValid = validateDocumentTypeForm()

        if(!isTypeDocValid) {
            formValid = false
        }

        function validateCompanyRucValid() {
            // RUC cantidad de dígitos
            if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
                if ( $('#enova-billing-doc-ruc').val().length < 11 ) {
                    return false
                }
            }

            return true
        }

        var isCompanyRucValid = validateCompanyRucValid()
        if(!isCompanyRucValid) {
            formValid = false
        }
      

        if(formValid) {
            console.log("El formulario correcto datos")

            document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true")
            checkoutButtonLoader(true)

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },    
                body: JSON.stringify(obj_params)
            })
            .then(response => {
                return response.json();
            })
            .then(response => {
                console.log("CART response", response)
    
                document.querySelector("#enova-message-carrito").classList.remove("active")
                /*
                * CREATE CHECKOUT: DEFAULT
                */
                // document.querySelector(".cart__checkout-button").click()

                // GET CART
                // getResponseCartItems(true)
                //     .then((carritoItemsListE) => {
                //         console.log("CARRITO READY", carritoItemsListE)
                //         if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                //             // Digital Product
                //             // document.querySelector(".cart__checkout-button").click()
                //         } else {
                //             // Shipping
                //         }
                //     })


                /**
                * CREATE CHECKOUT: STOREFRONT CUSTOM
                */
                serviceCart2CheckoutStoreFrontAPI(obj_params)
                    .then((result) => {
                        console.log("result 1", result)

                        if(result && result.message && result.name === "Error") {
                            console.log("Result es tipo Error", result)
                            checkoutButtonLoader(false)
                            throw result
                        }
                        
                        if(result && result.checkout && result.checkout.webUrl) {
                            checkoutButtonLoader(true)
                            console.log("PROCESO TERMINADO CHECKOUT", result)
                            setLocalStorageCustomerData()
                            window.location.href = getCheckoutRedirectUrl(result.checkout, obj_params.attributes)
                        } else {
                            throw result
                        }
                    })
                    .catch((err) => {
                        console.log("err message final", err)
                        setLocalStorageCustomerData()
                        window.location.href = buildThemeCheckoutUrl(obj_params.attributes)
                    })
    
            })
            .catch((error) => {
                console.error('CART Error:', error);
            });

  
        } else {
            console.log("El formulario falta datos")

            // Add class for error border
            if (obj_params.attributes.email === "") {
              document.querySelector("#enova-billing-email").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-email").classList.remove("input-has-error")
            }
            if (obj_params.attributes.nombre === "") {
              document.querySelector("#enova-billing-name").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-name").classList.remove("input-has-error")
            }
            if (obj_params.attributes.apellido === "") {
              document.querySelector("#enova-billing-lastName").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-lastName").classList.remove("input-has-error")
            }
            if (obj_params.attributes.telefono === "") {
              document.querySelector("#enova-billing-telefono").classList.add("input-has-error")
              if ( $(".text-has-error.text-phone").length == 0 ) {
                $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>")
              }
            } else {
              if ( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
                document.querySelector("#enova-billing-telefono").classList.add("input-has-error")
                if ( $(".text-has-error.text-phone").length == 0 ) {
                  $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>")
                }
              } else {
                document.querySelector("#enova-billing-telefono").classList.remove("input-has-error")
                $("p.text-has-error.text-phone").remove();
              }
            }
            if (obj_params.attributes["Documento Identidad"] === "") {
              document.querySelector("#enova-billing-documento-number").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error")
              // validar type doc
              validateDocumentTypeForm()
            }
            if (obj_params.attributes["tipo de envio"] === "") {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.add("text-has-error")
              } else {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.remove("text-has-error")
              }

            if (obj_params.attributes["Modalidad despacho"] === "delivery") {
              if (obj_params.attributes.direccion === "") {
                document.querySelector("#enova-despacho-direccion").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-despacho-direccion").classList.remove("input-has-error")
              }
              if (obj_params.attributes.referencia === "") {
                document.querySelector("#enova-despacho-referencia").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-despacho-referencia").classList.remove("input-has-error")
              }
              if (obj_params.attributes.departamento === "Seleccione...") {
                document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.remove("input-has-error")
              }
              if (obj_params.attributes.provincia === "Seleccione") {
                document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.remove("input-has-error")
              }
              if (obj_params.attributes.distrito === "Seleccione") {
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.remove("input-has-error")
              }
             
            }

            // validacion error despacho selected
            if( document.querySelector("input[name=enova-despacho]:checked") ) {
                // clean error
                document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.remove("input-has-error")
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").hide()

            } else {
                // error
                document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.add("input-has-error")

                if(
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option") &&
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option")[0]
                ) {
                    // show
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").show()
                    
                } else {
                    // create
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de Despacho</div>`)

                }
            }

            // validacion error billing selected
            if( document.querySelector("input[name=enova-billing-doc]:checked") ) {
                document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.remove("input-has-error")
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").hide()

            } else {
                document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.add("input-has-error")

                if(
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option") &&
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option")[0]
                ) {
                    // show
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").show()
                    
                } else {
                    // create
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de comprobante</div>`)

                }
            }


            // validacion error billing selected
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.remove("input-has-error")
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").hide()

            } else {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.add("input-has-error")

                if(
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option") &&
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option")[0]
                ) {
                    // show
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").show()
                    
                } else {
                    // create
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").append(`<div class="msg-error-not-selected-option">Debes seleccionar metodo de envio.</div>`)

                }
            }

            if (isCompanyRucValid) {
                document.querySelector("#enova-billing-doc-ruc").classList.remove("input-has-error")
                $("#enova-billing-documento-number").parent().append(`<p class='text-has-error text-typedoc'></p>`)
            } else {
                document.querySelector("#enova-billing-doc-ruc").classList.add("input-has-error")
                
                var message_validation = "El campo N de RUC debe tener 11 dígitos"
                $("#enova-billing-doc-ruc").parent().append(`<p class='text-has-error text-typedoc'>${message_validation}</p>`)
            }

            if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
                if ( jQuery("#enova-billing-doc-razonsocial").val() === "" ) {
                    document.querySelector("#enova-billing-doc-razonsocial").classList.add("input-has-error")
                } else {
                    document.querySelector("#enova-billing-doc-razonsocial").classList.remove("input-has-error")
                }
            }



            // enova-carrito-block-despacho-shipping-tipo__delivery--list

            // END Add class for error border

            document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false")

            document.querySelector("#enova-message-carrito").textContent = "Debes completar las casillas faltantes en rojo"
            document.querySelector("#enova-message-carrito").classList.add("active")
          
        }

    })

}

var setCheckerCartDiscountLabel = setInterval(() => {
    if (window.location.href.includes("cart") && 
    // document.querySelector(".cart__recap") && 
    !(document.querySelector("#enova_cart-data-submit")) ) {
        setFakeButtonCart()

        // GET CART
        getResponseCartItems(true)
            .then((carritoItemsListE) => {
                console.log("CARRITO READY", carritoItemsListE)
                if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                    // is Digital/Service Products
                    // jQuery(".enova-carrito-block").removeClass("active")
                    // jQuery("#enova_cart-data-submit").hide()
                    // jQuery("button.cart__checkout-button:first").show()

                    // show buttons
                    jQuery(".enova-carrito-block").addClass("active")
                    jQuery("#enova_cart-data-submit").show()

                    // hide options
                    jQuery(".enova-carrito-block-seleccion-despacho").hide()

                    jQuery("#despacho-title").hide()
                    jQuery(".enova-carrito-block-despacho-shipping__title").text("Ingrese su dirección de facturación")

                    // auto select Shipping opcion
                    jQuery(".enova-carrito-block-seleccion-despacho__container #enova-despacho-delivery-option").parent().click()

                    // remove shipping active default option
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery").removeClass("active")

                } else {
                    // is Shipping Products
                    jQuery(".enova-carrito-block").addClass("active")
                    jQuery("#enova_cart-data-submit").show()
                }
            })

        // set form data
        initSetFormDataUbigeosAvailable()

    }
}, 1000)

 // Validate CART has digital product
 function isCarritoProductTypeShipping(cartList) {
    let isCarritoReadyForShipping = false;
    
    for(let product of cartList) {
        let isShipping = product.requires_shipping
        if(isShipping) {
            // grams "0" = Producto digital
            // grams "0 >" = Producto fisico
            isCarritoReadyForShipping = true
            break;
        }
    }

    if(cartList && cartList.length === 0) {
        isCarritoReadyForShipping = true
    }

    return isCarritoReadyForShipping
}

const ENOVA_STOREFRONT_DOMAIN = "scooterland-peru.myshopify.com"
const ENOVA_STOREFRONT_TOKEN = "feb45a791fb85d9c735e5f152dc7224a"
const ENOVA_STOREFRONT_API_VERSION = "2025-07"

function isEmptyAddressValue(value) {
    const text = String(value == null ? "" : value).trim()
    return !text || text === "-" || text === "Seleccione" || text === "Seleccione..."
}

function formatPeruPhone(phone) {
    const raw = String(phone == null ? "" : phone).trim()
    const digits = raw.replace(/\D/g, "")
    if (!digits) {
        return ""
    }
    if (raw.startsWith("+") && digits.length >= 11) {
        return "+" + digits
    }
    if (digits.startsWith("51") && digits.length === 11) {
        return "+" + digits
    }
    if (digits.length === 9) {
        return "+51" + digits
    }
    return "+51" + digits
}

function getPeruProvinceCode(departamento) {
    const name = String(departamento || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")

    const map = {
        amazonas: "PE-AMA",
        ancash: "PE-ANC",
        apurimac: "PE-APU",
        arequipa: "PE-ARE",
        ayacucho: "PE-AYA",
        cajamarca: "PE-CAJ",
        callao: "PE-CAL",
        "el callao": "PE-CAL",
        cusco: "PE-CUS",
        cuzco: "PE-CUS",
        huancavelica: "PE-HUV",
        huanuco: "PE-HUC",
        ica: "PE-ICA",
        junin: "PE-JUN",
        "la libertad": "PE-LAL",
        lambayeque: "PE-LAM",
        lima: "PE-LIM",
        "municipalidad metropolitana de lima": "PE-LIM",
        loreto: "PE-LOR",
        "madre de dios": "PE-MDD",
        moquegua: "PE-MOQ",
        pasco: "PE-PAS",
        piura: "PE-PIU",
        puno: "PE-PUN",
        "san martin": "PE-SAM",
        tacna: "PE-TAC",
        tumbes: "PE-TUM",
        ucayali: "PE-UCA"
    }

    return map[name] || ""
}

function omitEmptyAddressFields(address) {
    const compact = {}
    Object.keys(address).forEach((key) => {
        const value = address[key]
        if (value != null && String(value).trim() !== "") {
            compact[key] = typeof value === "string" ? value.trim() : value
        }
    })
    return compact
}

function mapPrecheckoutToShippingAddress(attrs) {
    const direccion = isEmptyAddressValue(attrs.direccion) ? "" : String(attrs.direccion).trim()
    const referencia = isEmptyAddressValue(attrs.referencia) ? "" : String(attrs.referencia).trim()
    const distrito = isEmptyAddressValue(attrs.distrito) ? "" : String(attrs.distrito).trim()
    const provincia = isEmptyAddressValue(attrs.provincia) ? "" : String(attrs.provincia).trim()
    const departamento = isEmptyAddressValue(attrs.departamento) ? "" : String(attrs.departamento).trim()
    const provinceCode = getPeruProvinceCode(departamento)

    let address1 = direccion
    if (referencia && address1 && address1.indexOf(referencia) === -1) {
        address1 = address1 + ", " + referencia
    } else if (!address1 && referencia) {
        address1 = referencia
    }

    const company = attrs["comprobante de pago"] === "factura"
        ? [attrs.ruc, attrs["razon social"]].filter(Boolean).join(" ").trim()
        : (attrs["Documento Identidad"] || "")

    return omitEmptyAddressFields({
        address1: address1,
        address2: distrito,
        city: provincia || distrito,
        company: company,
        firstName: attrs.nombre || "",
        lastName: attrs.apellido || "",
        phone: formatPeruPhone(attrs.telefono),
        country: "Peru",
        province: provinceCode || departamento,
        zip: ""
    })
}

function buildThemeCheckoutUrl(attrs) {
    const address = mapPrecheckoutToShippingAddress(attrs || {})
    const params = new URLSearchParams()

    if (attrs && attrs.email) {
        params.set("checkout[email]", attrs.email)
    }

    const shippingFields = {
        first_name: address.firstName,
        last_name: address.lastName,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        province: address.province,
        country: "PE",
        zip: address.zip,
        phone: address.phone,
        company: address.company
    }

    Object.keys(shippingFields).forEach((key) => {
        if (shippingFields[key]) {
            params.set("checkout[shipping_address][" + key + "]", shippingFields[key])
        }
    })

    return "/checkout?" + params.toString()
}

function getCheckoutRedirectUrl(checkout, attrs) {
    if (checkout && checkout.webUrl) {
        try {
            const url = new URL(checkout.webUrl)
            url.searchParams.set("_fd", "0")
            return url.toString()
        } catch (err) {
            return checkout.webUrl
        }
    }

    const checkoutId = checkout && checkout.id ? String(checkout.id) : ""
    const cartPart = checkoutId.split("gid://shopify/Cart/")[1]
    if (cartPart) {
        const joiner = cartPart.indexOf("?") >= 0 ? "&" : "?"
        return "https://scooterland.pe/cart/c/" + cartPart + joiner + "channel=buy_button&_fd=0"
    }

    return buildThemeCheckoutUrl(attrs)
}

async function attachCartDeliveryAddress(cartId, mailingAddress) {
    if (!cartId || !mailingAddress) {
        return false
    }

    const provinceCode = String(mailingAddress.province || "").indexOf("PE-") === 0
        ? mailingAddress.province
        : getPeruProvinceCode(mailingAddress.province)

    const deliveryAddress = omitEmptyAddressFields({
        address1: mailingAddress.address1,
        address2: mailingAddress.address2,
        city: mailingAddress.city,
        company: mailingAddress.company,
        countryCode: "PE",
        firstName: mailingAddress.firstName,
        lastName: mailingAddress.lastName,
        phone: mailingAddress.phone,
        provinceCode: provinceCode,
        zip: mailingAddress.zip
    })

    try {
        const identityResponse = await fetch("https://" + ENOVA_STOREFRONT_DOMAIN + "/api/" + ENOVA_STOREFRONT_API_VERSION + "/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": ENOVA_STOREFRONT_TOKEN
            },
            body: JSON.stringify({
                query: "mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { cart { id checkoutUrl } userErrors { field message } } }",
                variables: {
                    cartId: cartId,
                    buyerIdentity: omitEmptyAddressFields({
                        email: mailingAddress.email,
                        phone: mailingAddress.phone,
                        countryCode: "PE"
                    })
                }
            })
        })
        const identityJson = await identityResponse.json()
        console.log("cartBuyerIdentityUpdate", identityJson)

        const addressResponse = await fetch("https://" + ENOVA_STOREFRONT_DOMAIN + "/api/" + ENOVA_STOREFRONT_API_VERSION + "/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": ENOVA_STOREFRONT_TOKEN
            },
            body: JSON.stringify({
                query: "mutation cartDeliveryAddressesAdd($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) { cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) { cart { id checkoutUrl } userErrors { field message } } }",
                variables: {
                    cartId: cartId,
                    addresses: [{
                        selected: true,
                        address: {
                            deliveryAddress: deliveryAddress
                        }
                    }]
                }
            })
        })
        const addressJson = await addressResponse.json()
        console.log("cartDeliveryAddressesAdd", addressJson)

        if (addressJson && addressJson.errors && addressJson.errors.length) {
            return false
        }

        const payload = addressJson && addressJson.data && addressJson.data.cartDeliveryAddressesAdd
        if (!payload || !payload.cart) {
            return false
        }

        const userErrors = payload.userErrors || []
        return userErrors.length === 0
    } catch (err) {
        console.log("attachCartDeliveryAddress error", err)
        return false
    }
}

async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
    try {
        async function createCheckout(client, inputCheckout) {

            let inputData = {
                email: inputCheckout.email,
                lineItems: inputCheckout.lineItems,
                shippingAddress: inputCheckout.shippingAddress,
                customAttributes: inputCheckout.customAttributes,
                buyerIdentity: {
                    countryCode: "PE"
                }
            }

            // Create an empty checkout
            let checkoutResponse = await client.checkout.create(inputData).then((checkout) => {
                // Do something with the checkout
                return checkout
            });
    
            return checkoutResponse
        }
    
        async function checkoutAddItems(client, checkoutId, lineItemsToAdd) {
            // UPDATE CHECKOUT - Add an item to the checkout
            let responseItems = await client.checkout.addLineItems(checkoutId, lineItemsToAdd)
            .then((checkout) => {
                console.log("checkoutA", checkout);
                return checkout
            })
            .catch((err) => {
                console.log("error", err)
            })
    
            return responseItems
        }
    
        async function checkoutAddAttributes(client, checkoutId, input) {
            let responseAttributes = await client.checkout.updateAttributes(checkoutId, input)
            .then((checkout) => {
                // Do something with the updated checkout
    
                return checkout
            });
    
            return responseAttributes
        }
    
        
        function getCartAttributesFormatted(cartAttributes) {
            // UPDATE CHECKOUT - checkout attributes
            let checkoutattrs = []
            for(let cartKey in cartAttributes.attributes) {
                let objectAttributes = {
                    key: cartKey,
                    value: cartAttributes.attributes[cartKey]
                }
                checkoutattrs.push(objectAttributes)
            }
        
            // let cartAtributesList = {
            //     customAttributes: checkoutattrs
            // };
            let cartAtributesList = checkoutattrs
            return cartAtributesList
        }
    
        async function getCheckoutById(checkoutId) {
            // Fetching a Checkout
            let checkoutPaylaod =  client.checkout.fetch(checkoutId).then((checkout) => {
                return checkout
            });
    
            return checkoutPaylaod
        }
    
    
        function checkoutUpdateAddress(shippingAddress) {
            const shippingAddressObj = mapPrecheckoutToShippingAddress(shippingAddress)
            console.log("shippingAddress", shippingAddress)
            console.log("shippingAddressObj", shippingAddressObj)
            return shippingAddressObj
        }

        async function checkoutUpdateAddressSendAPI(client, checkoutId, shippingAddressObj) {
            console.log("shippingAddressObj", shippingAddressObj)

            // Update the shipping address for an existing checkout.
            let checkoutAddressResponse = await client.checkout.updateShippingAddress(checkoutId, shippingAddressObj).then(checkout => {
                // Do something with the updated checkout
                console.log("CHECKOUT UPDATED2", checkout)
                return checkout
            });
    
            return checkoutAddressResponse
        }
    
        async function checkoutUpdateEmail(client, checkoutId, email) {
            let checkoutEmailResponse = await client.checkout.updateEmail(checkoutId, email).then((checkout) => {
                console.log("Email updated", checkout)
                return checkout
            });
    
            return checkoutEmailResponse
        }
    
        // Initializing a client to return content in the store's primary language
        let client = ShopifyBuy.buildClient({
            domain: 'scooterland-peru.myshopify.com',
            storefrontAccessToken: 'feb45a791fb85d9c735e5f152dc7224a'
        });
        
    
        // GET CART
        let carritoItemsList = await getResponseCartItems()

        console.log("carritoItemsList", carritoItemsList)
        let checkoutAtributesList = getCartAttributesFormatted(cartAttributes)
        let checkoutAddressParsed2Checkout = checkoutUpdateAddress(cartAttributes.attributes)

        let inoutCheckout2Create = {
            email: cartAttributes.attributes.email,
            lineItems: carritoItemsList,
            shippingAddress: checkoutAddressParsed2Checkout,
            customAttributes: checkoutAtributesList,
            buyerIdentity: {
                countryCode: "PE"
            }
        }

        console.log("checkout create", inoutCheckout2Create)

        let checkout = await createCheckout(client, inoutCheckout2Create)

        if (!(checkout && checkout.id)) {
            throw "error create checkout"
        }

        checkoutAddressParsed2Checkout.email = cartAttributes.attributes.email
        const addressAttached = await attachCartDeliveryAddress(checkout.id, checkoutAddressParsed2Checkout)

        if (!addressAttached) {
            return {
                checkout: {
                    id: checkout.id,
                    webUrl: buildThemeCheckoutUrl(cartAttributes.attributes)
                }
            }
        }

        console.log("CHECKOUT", checkout)
        return ({ checkout: checkout })
        
        // const checkoutId = checkout.id
        // let lineItemsToAdd = carritoItemsList
        // let checkoutAddLineItems = await checkoutAddItems(client, checkoutId, lineItemsToAdd)
        
        // console.log("checkoutAddLineItems", checkoutAddLineItems.lineItems)
        // if (!(checkoutAddLineItems.lineItems && checkoutAddLineItems.lineItems.length)) {
        //     throw "err1"
        // }
    
        // let checkoutAtributesList = getCartAttributesFormatted(cartAttributes)
        // let checkoutResponseAttributes = await checkoutAddAttributes(client, checkoutId, checkoutAtributesList)
        // let checkoutPayloadResponse = await getCheckoutById(checkoutId)
    
        // if(!(checkoutResponseAttributes && checkoutPayloadResponse && checkoutPayloadResponse.id)) {
        //     throw "err2"
        // }
    
        // let checkoutAddressParsed2Checkout = checkoutUpdateAddress(cartAttributes.attributes)
        // let checkoutAddressUpdated = await checkoutUpdateAddressSendAPI(client, checkoutId, checkoutAddressParsed2Checkout)
        // console.log("CHECKOUT FINISHED?", checkoutAddressUpdated)
    
        // let email = cartAttributes.attributes.email
        // let checkoutEmail = await checkoutUpdateEmail(client, checkoutId, email)
        
        
        // if(checkoutAddressUpdated && checkoutAddressUpdated && checkoutAddressUpdated.shippingAddress && checkoutEmail) {
        //     return ({checkout: checkoutAddressUpdated })
        // } else {
        //     throw "err3"
        // }

    } catch(err) {
        console.log("error", err)
        return {
            checkout: {
                webUrl: buildThemeCheckoutUrl(cartAttributes.attributes)
            }
        }
    }
}


async function getResponseCartItems(format = null) {
    let carritoItems = []

    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET'
    })

    const dataCart = await responseCart.json();
    for(let item of dataCart.items) {

        let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`
        function utf8_to_b64(str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        }
            
        let getUbigeoSelected = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo")
        let getShippingMethod = jQuery("input[name=enova-despacho-tipo]:checked").val()
        let getDespacho = jQuery("input[name=enova-despacho]:checked").val()

        let lineItemsToAdd = {
            variantId: utf8_to_b64(varianIdEncoded64),
            quantity: item.quantity,
            attributes: [
                {key: "tipo de despacho", value: getDespacho},
                {key: "shipping method", value: getShippingMethod},
                {key: "ubigeo", value: String(getUbigeoSelected) },
                {key: "peso", value: String(item.grams) },
                {key: "sku", value: String(item.sku) }
            ]
            // customAttributes: [
            //     {key: "tipo de despacho", value: getDespacho},
            //     {key: "shipping method", value: getShippingMethod},
            //     {key: "ubigeo", value: String(getUbigeoSelected) },
            //     {key: "peso", value: String(item.grams) },
            //     {key: "sku", value: String(item.sku) }
            // ]
        }

        if(format) {
            let isShipping = item.grams && item.grams > 0 ? true : false
            lineItemsToAdd['requires_shipping'] = isShipping    
            lineItemsToAdd['requires_shipping'] = true // FORCE ALL FISICAL ITEMS  - SHIPPING
        }

        carritoItems.push(lineItemsToAdd)

    }

    return carritoItems
} 


async function populate(scope = "departaments", options) {
    try {
         // 
        let countrySelected = options.country
        let departamentoSelected = options.departament
        let provinceSelected = options.district

        let urlBuilder = null

        if(scope === "departaments") {
            urlBuilder = `?scope=departaments&country=${countrySelected}`
            
        } else if (scope === "provinces") {
            urlBuilder = `?scope=provinces&country=${countrySelected}&departament=${departamentoSelected}`
            
        } else if (scope === "distrits") {
            urlBuilder = `?scope=distrits&country=${countrySelected}&departament=${departamentoSelected}&province=${provinceSelected}`
        }
         

        //  recojo en tienda
        let departamentos = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
            "method": "GET",
            "headers": {
                'Content-Type': 'application/json'
            }
        })
        .then((res) => res.json())
        .then((response) => {
            let filteredResponse = response.filter((item) => {
                if("is_active" in item) {
                    return item.is_active
                } else {
                    return item
                }
            })

            return filteredResponse
        })
        .then((response) => {
            console.log("response", response)
            return response
        })
        .catch(error => console.error('Error:', error))

        console.log("UBIGEOS - ", scope, departamentos)
 
        return departamentos
 
    } catch(err) {
         console.log("err", err)
         return err
    }
 
}
 
async function getPickUpShopList(filter_zona = null) {

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("")
    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("<p>Validando</p>")

    //  recojo en tienda
    let shopsList = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation?scope=shop-addresses`, {
        "method": "GET",
        "headers": {
            'Content-Type': 'application/json'
        }
    })
    .then((res) => res.json())
    .then((response) => {
        return response.items
    })
    .catch(error => console.error('Error:', error))

    console.log("lista de tiendas", shopsList)

    // FILTRO STORE LIST
    let list_stores_filtered = []

    if(filter_zona) {
        list_stores_filtered = shopsList.filter((element) => {
            return element['department'] === filter_zona
        })

        // replace
        shopsList = list_stores_filtered;
    }

    // render on list
    // shopsList
    let templateBlockStoreList = ""

    for(let store of shopsList) {
        let templateItemElement = `
            <label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-${store.id}">
                <input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-${store.id}" data-departamento="${store.department}" data-provincia="${store.province}" data-distrito="${store.distrit_name}" data-ubigeo="${store.ubigeo}" />
                <div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">
                    <h3 class="enova-tienda-titulo">${store.name}</h3>
                    <p class="enova-tienda-direccion">${store.address}</p>
                </div>
            </label>
        `
        templateBlockStoreList += templateItemElement
    }

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(templateBlockStoreList)

    setTimeout(() => {
        setStoresEventClick()
    }, 300)

    return shopsList
}


function setStoreListFilter() {
    jQuery("#enova-carrito-block-despacho-recojo__filtro").on("change", (ev) => {
        console.log("event select changed", ev.target.value)
        let filter_store_selected = ev.target.value

        getPickUpShopList(filter_store_selected)
    })
}

setStoreListFilter()

function setResetSelectorOptions(scope, addressBilling = null) {
    let templateList = `<option value="">Seleccione</option>`
    if(scope === "departaments") {

        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList)
        }
    } else if(scope === "provinces") {

        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList)
        }

    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList)
        }
    }
}


function setSelectorOptions(scope, optionList, addressBilling = null) {
    if(scope === "departaments") {
        let templateList = '<option>Seleccione...</option>'
        for(let optionUbigeo of optionList) {
            let itemOptionTemplate = `
                <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
            `
            templateList += itemOptionTemplate;
        }
        
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList)
        }

        
    } else if(scope === "provinces") {

        let templateList = '<option>Seleccione...</option>'
        for(let optionUbigeo of optionList) {
            let itemOptionTemplate  = `
                <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
            `
            templateList += itemOptionTemplate;
        }

        
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList)
        }
        

    } else if (scope === "distrits") {

        let templateList = '<option>Seleccione...</option>'
        for(let optionUbigeo of optionList) {
            let itemOptionTemplate  = `
                <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
            `
            templateList += itemOptionTemplate;
        }
        
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList)
        }

    }

}


function initSetFormDataUbigeosAvailable() {

    setResetSelectorOptions('departaments')
    setResetSelectorOptions('provinces')
    setResetSelectorOptions('distrits')

    setResetSelectorOptions('departaments', true)
    setResetSelectorOptions('provinces', true)
    setResetSelectorOptions('distrits', true)


    // Init data deparments
    populate("departaments", {
        country: "1", // peru
        departament: null,
        district: null
    })
    .then((result) => {
        let departmentsList = result 
        setSelectorOptions("departaments", departmentsList)
        setSelectorOptions("departaments", departmentsList, true)
        
        let region = getCustomerData("region")
        if (region) {
            $("#enova-carrito-block-despacho-shipping__departamento").val(region).change()
        }

    })
    .catch((err) => {
        console.log("err ubigeo selector departaments", err)
    })




    /*
    * shipping address
    */

    // event departaments 
    jQuery("#enova-carrito-block-despacho-shipping__departamento").on("change", () => {

        setResetSelectorOptions('provinces')
        setResetSelectorOptions('distrits')


        // Get Provinces
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id") 
        let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo") 

        populate("provinces", {
            country: "1", // Peru
            departament: SelectedDepartamentoID,
            district: null
        })
        .then((result) => {
            let provincesList = result 
            setSelectorOptions("provinces", provincesList)

            let city = getCustomerData("city")
            if (city && $("#enova-carrito-block-despacho-shipping__departamento").val() == getCustomerData("region")) {
                $("#enova-carrito-block-despacho-shipping__provincia").val(city).change()
            }
        })
        .catch((err) => {
            console.log("err ubigeo selector provinces", err)
        })

    })


    // event provincia 
    jQuery("#enova-carrito-block-despacho-shipping__provincia").on("change", () => {
        setResetSelectorOptions('distrits')
        
        // Get distritos
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id") 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-shipping__provincia option:selected").data("id") 
        
        populate("distrits", {
            country: "1",
            departament: SelectedDepartamentoID,
            district: SelectedProvinciaID
        })
        .then((result) => {
            let districtList = result 
            setSelectorOptions("distrits", districtList)

            let locality = getCustomerData("locality")
            if (locality && $("#enova-carrito-block-despacho-shipping__provincia").val() == getCustomerData("city")) {
                $("#enova-carrito-block-despacho-shipping__distrito").val(locality)
                const distrito = document.querySelector("#enova-carrito-block-despacho-shipping__distrito");
                distrito.dispatchEvent(new Event("change", { bubbles: true }));

                $(`input[name="enova-despacho-tipo"][value="${getCustomerData("shippingMethodType")}"]`).prop('checked', true).trigger('change');
            }
        })
        .catch((err) => {
            console.log("err ubigeo selector distrits", err)
        })

    })


    // // event distrito 
    // jQuery("#enova-carrito-block-despacho-shipping__distrito").on("change", () => {
    //     // On change get shipping rates

    //     // CALL UBIGEO CALCULATOR
    // })



    /*
    * billing address
    */
    // event departaments 
    jQuery("#enova-carrito-block-despacho-billing__departamento").on("change", () => {

        setResetSelectorOptions('provinces', true)
        setResetSelectorOptions('distrits', true)


        // Get Provinces
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id") 
        let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-billing__distrito option:selected").data("ubigeo") 

        populate("provinces", {
            country: "1", // Peru
            departament: SelectedDepartamentoID,
            district: null
        })
        .then((result) => {
            let provincesList = result 
            setSelectorOptions("provinces", provincesList, true)
        })
        .catch((err) => {
            console.log("err ubigeo selector provinces", err)
        })

    })


    // event provincia 
    jQuery("#enova-carrito-block-despacho-billing__provincia").on("change", () => {
        setResetSelectorOptions('distrits', true)
        
        // Get distritos
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id") 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-billing__provincia option:selected").data("id") 
        
        populate("distrits", {
            country: "1",
            departament: SelectedDepartamentoID,
            district: SelectedProvinciaID
        })
        .then((result) => {
            let districtList = result 
            setSelectorOptions("distrits", districtList, true)
        })
        .catch((err) => {
            console.log("err ubigeo selector distrits", err)
        })

    })


    // event distrito 
    jQuery("#enova-carrito-block-despacho-billing__distrito").on("change", () => {
        // On change get shipping rates

        // CALL UBIGEO CALCULATOR
    })
    





    // event facturacion address
    jQuery("#formulario--billing-address_checkbox").on("change", (ev) => {
        console.log("event changed", jQuery(ev.currentTarget))
        
        if(
            !jQuery("#formulario--billing-address_checkbox").prop("checked")
        ) {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block")
        } else {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none")
        }
    })

}


function SetRenderShippingMethodsListOption(methodsList) {
    let templateList = ''
    const ubigeo = $('#enova-carrito-block-despacho-shipping__distrito option:selected').data('code');
    const esLima = String(ubigeo).startsWith('15');

    for(let method of methodsList) {
        let templateItem = `
            <div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">
                <input type="radio" 
                    name="enova-despacho-tipo" 
                    class="enova-delivery-method-1" 
                    id="enova-delivery-method-${method.code}" 
                    value="${method.code}">
                    
                <label for="enova-delivery-method-${method.code}" class="enova-shipping-label">
                    
                    <div class="enova-shipping-row-top">
                        <span class="enova-shipping-method-title">${ !esLima ? 'Envío a coordinar' : method.name}</span>
                        ${ esLima ? `<span class="enova-shipping-method-price">S/ ${method.price}</span>` : ''}
                    </div>

                    ${ !esLima ? `
                    <div class="enova-shipping-method-tag-description">
                        <p>${method.description}</p>
                    </div>
                    ` : '' }
                    
                </label>
            </div>
        `

        templateList += templateItem
    }
    
    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").html(templateList)

    calculateShippingMethodToShowOption()
}


function setRenderCartFormKeypressValidation() {
    jQuery('.page-content form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
    });

     // select document type
    jQuery("#enova-billing-documento-type").on("change", (ev) => {
        jQuery("#enova-billing-documento-number").val("")
        $("p.text-has-error.text-typedoc").remove()
        document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error")
      
    })

     // documento tpye
    jQuery("#enova-billing-documento-number").on("keypress", (ev) => {
        // Input doc type
        let input_doc_type_selected = jQuery("#enova-billing-documento-type").val()
        let currentLength = ev.currentTarget.value.length;

        if(input_doc_type_selected === "1") {
            // DNI
            regex = /^[0-9]$/; // Solo dígitos
            if (currentLength >= 8) {
                ev.preventDefault(); // Evita más entradas
            }

        } else if(input_doc_type_selected === "2") {
            // CE
            regex = /^[a-zA-Z0-9]$/; // Alfanumérico
            if (currentLength >= 12) {
                ev.preventDefault(); // Evita más entradas
            }

        } else if(input_doc_type_selected === "3") {
            // RUC
            regex = /^[0-9]$/; // Solo dígitos
            if (currentLength >= 11) {
                ev.preventDefault(); // Evita más entradas
            }
        } else {
            return; // Si no hay opción seleccionada, no hacer nada
        }

        // Validar la tecla presionada
        if (!regex.test(ev.key)) {
            ev.preventDefault(); // Evita la entrada de caracteres no válidos
        }
    })

    // telefono
    jQuery("#enova-billing-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) {
            ev.preventDefault();
        }
    })

    // ruc
    jQuery("#enova-billing-doc-ruc").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) {
            ev.preventDefault();
        }
    })

    // Update fields text
    $("[for='enova-billing-telefono']").text("Celular");

}

setRenderCartFormKeypressValidation()



/*
* Cart step 1
*/
function cartStep1() {
    let buttonCartCheckoutStep = document.querySelector(".enova_cart_button_step1")
    if (buttonCartCheckoutStep) {
        buttonCartCheckoutStep.addEventListener("click", (ev) => {
            console.log("eveneto click")

            let blockCartStep = document.querySelector(".enova-block-carrito-main")
            let blockCart = document.querySelector("#MinimogCart")

            // set auto click - reset "delivery"
            document.querySelector("input[name=enova-despacho]:first-child").click()

            if( blockCartStep.classList.contains("active") ) {
                // It's open - it's already open
                //blockCartStep.classList.remove("active")

                // show cart list
                //blockCart.classList.remove("closed")

            } else {
                // It's closed - first visit before checkout
                //blockCartStep.classList.add("active")

                // close cart list
                //blockCart.classList.add("closed")
            }

        })
    }

}

cartStep1()


/* LocalStorage */
const CUSTOMER_KEY = "customerData";
function setCustomerData(field, value) {
  let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
  data[field] = value;
  localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
}
function getCustomerData(field) {
  let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
  return data[field] || null;
}
function getAllCustomerData() {
  return JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
}
function clearCustomerData() {
  localStorage.removeItem(CUSTOMER_KEY);
}
function setLocalStorageCustomerData() {
    setCustomerData("firstName", $("#enova-billing-name").val())
    setCustomerData("lastName", $("#enova-billing-lastName").val())
    setCustomerData("email", $("#enova-billing-email").val())
    setCustomerData("phone", $("#enova-billing-telefono").val())
    setCustomerData("documentType", $("#enova-billing-documento-type").val())
    setCustomerData("documentNumber", $("#enova-billing-documento-number").val())

    setCustomerData("shippingMethodType", $('input[name="enova-despacho-tipo"]:checked').val())
    setCustomerData("shippingMethod", $('input[name="enova-despacho"]:checked').val())
    setCustomerData("region", $("#enova-carrito-block-despacho-shipping__departamento").val())
    setCustomerData("city", $("#enova-carrito-block-despacho-shipping__provincia").val())
    setCustomerData("locality", $("#enova-carrito-block-despacho-shipping__distrito").val())

    setCustomerData("address", $("#enova-despacho-direccion").val())
    setCustomerData("reference", $("#enova-despacho-referencia").val())

    setCustomerData("billingType", $('input[name="enova-billing-doc"]:checked').val())
    setCustomerData("ruc", $("#enova-billing-doc-ruc").val() || "")
    setCustomerData("companyName", $("#enova-billing-doc-razonsocial").val() || "")
    setCustomerData("loaded", false)
}
function setInitCustomerData() {
    const customerData = getAllCustomerData()
    if (Object.keys(customerData).length === 0) {
        if (window.ShopifyCustomer.logged_in) {
            $("#enova-billing-name").val(window.ShopifyCustomer.firstName)
            $("#enova-billing-lastName").val(window.ShopifyCustomer.lastName)
            $("#enova-billing-email").val(window.ShopifyCustomer.email)
        }
    } else {
        $("#enova-billing-name").val(getCustomerData("firstName"))
        $("#enova-billing-lastName").val(getCustomerData("lastName"))
        $("#enova-billing-email").val(getCustomerData("email"))
        $("#enova-billing-telefono").val(getCustomerData("phone"))
        $("#enova-billing-documento-type").val(getCustomerData("documentType"))
        $("#enova-billing-documento-number").val(getCustomerData("documentNumber"))
        $(`input[name="enova-despacho"][value="${getCustomerData("shippingMethod")}"]`).prop('checked', true).trigger('change');
    
        document.querySelector("#enova-despacho-shipping").classList.remove("disabled")
        document.querySelector("#enova-despacho-shipping").classList.add("active")
        $("#enova-despacho-direccion").val(getCustomerData("address"))
        $("#enova-despacho-referencia").val(getCustomerData("reference"))
    
        $(`input[name="enova-billing-doc"][value="${getCustomerData("billingType")}"]`).prop('checked', true).trigger('change');
        if (getCustomerData("billingType") == "factura") {
            $("#enova-billing-doc").css("display", "block")
            $("#enova-billing-doc-ruc").val(getCustomerData("ruc"))
            $("#enova-billing-doc-razonsocial").val(getCustomerData("companyName"))
        }
    }
}


/* END LocalStorage */

// function requestCartList() {
//     return new Promise((resolve, reject) => {
//         resolve('resolved');
//     });
// }

// // GET CARRITO
// let carritoItems = []


// fetch(window.Shopify.routes.root + 'cart.js', {
//     method: 'GET'
//   })
//   .then(response => {
//     return response.json();
//   })
//   .then(response => {

//     for(let item of response.items) {

//         let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`
//         let lineItemsToAdd = {
//             variantId: varianIdEncoded64,
//             quantity: item.quantity,
//             // customAttributes: [{key: "MyKey", value: "MyValue"}]
//         }

//         carritoItems.push(lineItemsToAdd)

//     }
    

//     console.log("CART response", response)
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });


// UPDATE CARRITO
// endpoint to update the cart's line item quantities, note, or attributes.

// var obj_params = {
//     note: 'This is a note about my order'
// }

// fetch(window.Shopify.routes.root + 'cart/update.js', {
//     method: 'POST',
//     headers: {
//         'Content-Type': 'application/json'
//     },    
//     body: JSON.stringify(obj_params)
    
//   })
//   .then(response => {
//     return response.json();
//   })
//   .then(response => {
//     console.log("CART response", response)
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });


//   fetch(window.Shopify.routes.root + 'cart/update.js?attributes[departamento]=Yes', {
// 


// function calculateShippingMethods() {
//     var checkerFormDespachoDelivery = setInterval(() => {
//         let checkoutDeloiveryForm = {
//             departamento: document.querySelector("#enova-carrito-block-despacho-shipping__departamento") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento").value : '',
//             provincia: document.querySelector("#enova-carrito-block-despacho-shipping__provincia") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia").value : '',
//             distrito: document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value : '',
//             direccion: document.querySelector("#enova-despacho-direccion") ? document.querySelector("#enova-despacho-direccion").value : '',
//             referencia: document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
//         }   

//         if( validateDeliveryForm(checkoutDeloiveryForm) ) {
       
//             // show shippingm methods
//             document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active")
//             document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled")
//         } else {
//             // hide shipping methods
//             document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active")
//             document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled")
//         }

//     }, 1000)

// }

//calculateShippingMethods()